import React, { useState } from 'react';
import './DesignCase.scss';
import { Text } from '../text/Text.tsx';
import IFigma from '../../resource/directory.png';
import { Popup } from '../home/popup/Popup.tsx';
import I1 from '../../resource/desktop_1.png';
import I2 from '../../resource/desktop_2.png';
import I3 from '../../resource/desktop_3.png';
import { FigmaProject } from './DesignCase.tsx';
import IAbout from '../../resource/about.png';
import { BoredRadio } from '../home/popup/BoredRadio.tsx';
import { TypewriterLetter } from '../home/popup/Typewriter.tsx';
import ICD from '../../resource/cd.png';

export const ApplicationsFolder: React.FC = () => {
    const [selectedProject, setSelectedProject] = useState<FigmaProject | undefined>(undefined);
    const [boredRadio, setBoredRadio] = useState<boolean>(false);
    const [typewriterLetter, setTypewriterLetter] = useState<boolean>(false);

    const projects: FigmaProject[] = [
        {
            id: 'redio',
            title: 'My radio',
            content: 'This is the detailed description for App 1.<end>It covers the UI design and layout in Figma.',
            files: [ICD]
        },
        {
            id: 'typewriter',
            title: 'Typewriter',
            content: 'This is the detailed description for App 2.<end>It showcases the color palette and typography.',
            files: [IFigma]
        }
    ];

    return (
        <div className="design-case">
            <div className="design-case-content">
                <div style={{ marginBottom: 32, marginTop: 48 }}>
                    <Text variant="body">
                        {`Applications folder`}
                    </Text>
                </div>

                <div className="figma-row">
                    {projects.map((project) => (
                        <div
                            key={project.id}
                            className="figma-app"
                            onClick={() => {
                                if (project.id === 'redio') {
                                    setBoredRadio(true);
                                }
                                else if (project.id === 'typewriter') {
                                    setTypewriterLetter(true);
                                }
                                else {
                                    setSelectedProject(project);
                                }
                            }}
                        >
                            <div className="figma-icon">
                                <img src={project.files[0]} alt="Figma Icon" />
                            </div>
                            <div className="figma-title">
                                <Text variant="subHeadline">
                                    {project.title.length > 10 ? `${project.title.substring(0, 10)}...` : project.title}
                                </Text>
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            {boredRadio && (
                <div
                    className="popup-overlay"
                    onClick={() => {
                    }}
                >
                    <BoredRadio
                        onClose={function (): void {
                            setBoredRadio(false);
                        }}
                    />
                </div>
            )}

            {typewriterLetter && (
                <div
                    className="popup-overlay"
                    onClick={() => {
                    }}
                >
                    <TypewriterLetter
                        onClose={function (): void {
                            setTypewriterLetter(false);
                        }}
                    />
                </div>
            )}

            {selectedProject && (
                <div className="popup-overlay" onClick={() => setSelectedProject(undefined)}>
                    <Popup
                        title={selectedProject.title}
                        content={selectedProject.content}
                        files={selectedProject.files}
                        allowFull={true}
                        onClose={() => setSelectedProject(undefined)}
                    />
                </div>
            )}
        </div>
    );
};
